<template>
  <v-overlay :model-value="modelValue" class="align-center justify-center" persistent>
    <v-card class="loading-card" elevation="8">
      <v-card-text class="text-center">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
          class="mb-4"
        ></v-progress-circular>
        <h3 class="loading-title">Loading...</h3>
        <p class="loading-subtitle">Please wait</p>
      </v-card-text>
    </v-card>
  </v-overlay>
</template>

<script>
// "Loading... / Please wait" busy overlay shared by the group admin list
// views. Markup moved verbatim; the .loading-card / .loading-title /
// .loading-subtitle styling lives in the global stylesheet
// (assets/styles/globals.css), so rendering is unchanged.
export default {
  name: "LoadingOverlay",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
